import createReducer from 'core/utils/redux';
import { types } from './actions';

export const initialState = {
	showPreloader: false,
	notifications: {},
	totalNotifications: '',
	setAnimate: false,
	enabled: false,
	polling: false
};

const reducer = {
	[types.SET_BADGE_NOTIFICATIONS](state, { notifications }) {
		return {
			...state,
			notifications,
			polling: false
		};
	},
	[types.GET_TOTAL_BADGE_NOTIFICATIONS](state) {
		return {
			...state,
			polling: true
		};
	},
	[types.SET_TOTAL_BADGE_NOTIFICATIONS_LOADED](state, { data }) {
		const setAnimate = data > 0 ? true : false;
		return {
			...state,
			totalNotifications: data,
			setAnimate,
			enabled: setAnimate
		};
	},
	[types.SET_BADGE_BADGE_ACTIVE](state, { setAnimate }) {
		return {
			...state,
			setAnimate
		};
	},
	[types.STOP_POLLING](state) {
		return {
			...state,
			notifications: {},
			setAnimate: false,
			polling: false
		};
	},
	[types.UPDATE_SHOW_PRELOADER](state, { bool }) {
		return {
			...state,
			showPreloader: bool
		};
	}
};

export default createReducer(initialState, reducer);
